import { ReactNode } from "react";
import Logo from "./Logo";
import loaderLogo from "../assets/placeholder_thumbnail.png";

const spinnerElement = (
  <div className="animate-spin" style={{ animationDuration: "2s" }}>
    <Logo loaderLogo={loaderLogo} size={40} />
  </div>
);

const Loader = ({
  spinning,
  children,
}: {
  spinning?: boolean;
  children?: ReactNode;
}) => {
  if (children !== undefined) {
    return (
      <div style={{ position: "relative" }}>
        {children}
        {spinning && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255, 255, 255, 0.6)",
              zIndex: 10,
              borderRadius: "inherit",
            }}
          >
            {spinnerElement}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="w-full min-h-[80vh] flex justify-center items-center">
      <div className="animate-spin" style={{ animationDuration: "2s" }}>
        <Logo loaderLogo={loaderLogo} size={80} />
      </div>
    </div>
  );
};

export default Loader;
